import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Calendar, MapPin, FileText, UserPlus, ArrowRight, Users, Lightbulb, Award, Play, Cpu, Bot, GraduationCap, Building, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import deptimg from '@/assets/22.jpg';
import heroVideo from "../assets/hero-video.mp4";

const Home = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.4 },
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const importantDates = [
    { event: 'First Call for Papers', date: '1 July 2026', icon: FileText },
    { event: 'Paper Submission Deadline', date: '15 Oct 2026', icon: FileText },
    { event: 'Notification of Acceptance', date: '30 Nov 2026', icon: Award },
    { event: 'Camera Ready Submission', date: '20 Dec 2026', icon: FileText },
    { event: 'Early Bird Registration', date: '1-31 Dec 2026', icon: UserPlus },
    { event: 'Conference Dates', date: '19-20 Feb 2027', icon: Calendar },
  ];

  return (
    <div data-testid="home-page">
      {/* Hero Section */}
      <section className="relative min-h-[85vh] flex items-center overflow-hidden" data-testid="hero-section">

  {/* Background Video */}
  <video
    autoPlay
    loop
    muted
    playsInline
    className="absolute inset-0 w-full h-full object-cover"
  >
    <source src={heroVideo} type="video/webm" />
  </video>

  {/* Dark Overlay for readability */}
  <div className="absolute inset-0 bg-black/50"></div>

  {/* Optional pattern */}
  <div className="absolute inset-0 grid-pattern opacity-20"></div>

  {/* Content */}
  <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20 relative z-10">
    <motion.div
      className="max-w-4xl"
      initial="initial"
      animate="animate"
      variants={staggerContainer}
    >

      <motion.h2
        variants={fadeInUp}
        className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6"
      >
        1<sup>st</sup> International Conference on{' '}
        <span className="text-[#B6671D]" style={{
    WebkitTextStroke: "0.3px white",
  }}>Robotics, Automation</span> and Smart Manufacturing
      </motion.h2>

      <motion.p
        variants={fadeInUp}
        className="font-inter text-xl text-white/90 mb-6 leading-relaxed max-w-3xl"
      >
        Intelligent Robotics, Smart Manufacturing and Sustainable Technologies for a Resilient Future
      </motion.p>

      <motion.div variants={fadeInUp} className="flex items-center space-x-4 text-white/80 mb-8">
        <div className="flex items-center space-x-2">
          <Calendar size={20} className="text-[#B6671D]" />
          <span className="font-inter text-base font-medium">19–20 Feb 2027</span>
        </div>
        <span className="text-white/40">|</span>
        <div className="flex items-center space-x-2">
          <MapPin size={20} className="text-[#B6671D]" />
          <span className="font-inter text-base">Department of Mechatronics Engineering, MUJ</span>
        </div>
      </motion.div>

      <motion.div variants={fadeInUp} className="flex flex-wrap gap-4">
        <Link to="/for-authors">
          <Button className="bg-[#B6671D] hover:bg-[#9A571A] text-white px-8 py-6 rounded-md font-semibold shadow-lg transition-all">
            <FileText className="mr-2" size={20} />
            Submit Paper
          </Button>
        </Link>

        <Link to="/for-authors">
          <Button
            variant="outline"
            className="border-2 border-white text-white hover:bg-white hover:text-slate-900 px-8 py-6 rounded-md font-medium transition-all"
          >
            <UserPlus className="mr-2" size={20} />
            Register Now
          </Button>
        </Link>
      </motion.div>

    </motion.div>
  </div>
</section>
     {/*  <section className="relative min-h-[85vh] flex items-center mesh-gradient overflow-hidden" data-testid="hero-section">
        <div className="absolute inset-0 grid-pattern"></div>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20 relative z-10">
          <motion.div
            className="max-w-4xl"
            initial="initial"
            animate="animate"
            variants={staggerContainer}
          >
           {/* <motion.div variants={fadeInUp} className="inline-block mb-4">
              <span className="px-4 py-2 bg-[#B6671D]/10 text-[#B6671D] rounded-full text-sm font-inter font-medium">
                19–20 February 2027 • Manipal University Jaipur
              </span>
            </motion.div> */}
            {/*
            <motion.h2
              variants={fadeInUp}
              className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-950 leading-tight tracking-tight mb-6"
            >
              1<sup>st</sup> International Conference on{' '}
              <span className="text-[#B6671D]">Robotics, Automation</span> and Smart Manufacturing
            </motion.h2>

            <motion.p
              variants={fadeInUp}
              className="font-inter text-xl text-slate-600 mb-6 leading-relaxed max-w-3xl"
            >
              Intelligent Robotics, Smart Manufacturing and Sustainable Technologies for a Resilient Future
            </motion.p>

            <motion.div variants={fadeInUp} className="flex items-center space-x-4 text-slate-700 mb-8">
              <div className="flex items-center space-x-2">
                <Calendar size={20} className="text-[#B6671D]" />
                <span className="font-inter text-base font-medium">19–20 Feb 2027</span>
              </div>
              <span className="text-slate-300">|</span>
              <div className="flex items-center space-x-2">
                <MapPin size={20} className="text-[#B6671D]" />
                <span className="font-inter text-base">Department of Mechatronics Engineering, MUJ</span>
              </div>
            </motion.div>

            <motion.div variants={fadeInUp} className="flex flex-wrap gap-4">
              <Link to="/for-authors">
                <Button
                  className="bg-slate-950 hover:bg-slate-800 text-white px-8 py-6 rounded-md font-semibold shadow-lg transition-all hover:-translate-y-0.5"
                  data-testid="submit-paper-button"
                >
                  <FileText className="mr-2" size={20} />
                  Submit Paper
                </Button>
              </Link>
              <Link to="/for-authors">
                <Button
                  variant="outline"
                  className="border-2 border-slate-950 text-slate-950 hover:bg-slate-950 hover:text-white px-8 py-6 rounded-md font-medium transition-all"
                  data-testid="register-button"
                >
                  <UserPlus className="mr-2" size={20} />
                  Register Now
                </Button>
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section> */}

      {/* Important Dates Section - Improved Design */}
      <section className="py-16 bg-slate-950" data-testid="important-dates-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="text-center mb-10">
            <div className="inline-flex items-center space-x-2 mb-4">
              <Clock className="text-[#B6671D]" size={28} />
              <h2 className="font-outfit text-2xl sm:text-3xl font-bold text-white">Important Dates</h2>
            </div>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {importantDates.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: index * 0.05 }}
                className={`bg-slate-900 border border-slate-800 rounded-xl p-4 text-center hover:border-[#B6671D]/50 transition-all ${
                  item.event === 'Conference Dates' ? 'bg-[#B6671D]/20 border-[#B6671D]' : ''
                }`}
                data-testid={`date-card-${index}`}
              >
                <item.icon className={`mx-auto mb-3 ${item.event === 'Conference Dates' ? 'text-[#B6671D]' : 'text-slate-500'}`} size={24} />
                <p className="font-mono text-lg font-bold text-white mb-1">{item.date}</p>
                <p className="font-inter text-xs text-slate-400 leading-tight">{item.event}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Conference Introduction */}
      <section className="py-24 md:py-32 bg-white" data-testid="intro-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="max-w-4xl mx-auto text-center mb-16"
          >
            <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-950 mb-6">
              About <span className="text-[#B6671D]">IRASM-2027</span>
            </h2>
            <p className="font-inter text-lg text-slate-600 leading-relaxed">
              The International Conference on Robotics, Automation and Smart Manufacturing (IRASM-2027) aims to create
              a global platform for researchers, academicians, industry experts, and policymakers to discuss advancements
              in robotics, automation, artificial intelligence, smart manufacturing, aerospace systems, electric mobility,
              and drone technologies.
            </p>
            <div className="bg-[#B6671D]/10 border-l-4 border-[#B6671D] p-6 rounded-r-lg">
                <p className="font-semibold text-slate-900 mb-2">Publication Opportunity</p>
                <p>
                  Accepted and presented papers will be submitted for publication in international conference proceedings
                  indexed in <strong>Web of Science, Scopus, and Inspec</strong>.
                </p>
              </div>
          </motion.div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: Users,
                title: 'Global Collaboration',
                description: 'Connect with researchers and industry experts from around the world',
              },
              {
                icon: Lightbulb,
                title: 'Innovation & Research',
                description: 'Explore cutting-edge advancements in robotics and smart manufacturing',
              },
              {
                icon: Award,
                title: 'Indexed Publications',
                description: 'Papers published in proceedings indexed in Web of Science & Scopus',
              },
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="bg-white border border-slate-200 rounded-xl p-8 hover:shadow-xl hover:border-[#B6671D]/50 transition-all duration-300 group"
                data-testid={`feature-card-${index}`}
              >
                <div className="w-14 h-14 bg-[#B6671D]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#B6671D] transition-colors">
                  <feature.icon className="text-[#B6671D] group-hover:text-white transition-colors" size={28} />
                </div>
                <h3 className="font-outfit text-xl font-bold text-slate-950 mb-3">{feature.title}</h3>
                <p className="font-inter text-slate-600 leading-relaxed">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* About Manipal University Jaipur */}
      <section className="py-24 md:py-32 bg-slate-50" data-testid="about-muj-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Video Placeholder */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <div className="relative bg-slate-200 rounded-2xl overflow-hidden aspect-video" data-testid="muj-video-placeholder">
                <div className="rounded-xl overflow-hidden shadow-lg">
                  <video
                    className="w-full h-80 object-cover transition duration-300"
                    src="https://www.aciffs.in/assets/MUJ_Venue.webm"
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                </div>
              </div>
            </motion.div>

            {/* Content */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <div className="flex items-center space-x-3 mb-4">
                <Building className="text-[#B6671D]" size={28} />
                <h2 className="font-outfit text-3xl sm:text-4xl font-bold text-slate-950">
                  Manipal University Jaipur
                </h2>
              </div>
              <div className="space-y-4 font-inter text-slate-600 leading-relaxed">
                <p>
                  Manipal University Jaipur (MUJ), established in 2011, is a multidisciplinary private university located
                  in Jaipur, Rajasthan. Spread across a 122-acre campus at Dehmi Kalan, the university offers undergraduate,
                  postgraduate, and doctoral programs across engineering, management, law, design, sciences, and humanities.
                </p>
                <div className="grid grid-cols-2 gap-4 mt-6">
                  {[
                    { rank: 'NIRF 2025', detail: '58th Engineering' },
                    { rank: 'QS Asia 2025', detail: '701-800 band' },
                    { rank: 'THE 2025', detail: '1201-1500 globally' },
                    { rank: 'NIRF Overall', detail: '98th Rank' },
                  ].map((item, index) => (
                    <div key={index} className="bg-white border border-slate-200 rounded-lg p-4">
                      <p className="font-outfit text-sm font-semibold text-[#B6671D]">{item.rank}</p>
                      <p className="font-inter text-sm text-slate-700">{item.detail}</p>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* About Department of Mechatronics Engineering */}
      <section className="py-24 md:py-32 bg-white" data-testid="about-department-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
  
                {/* Content */}
                <motion.div
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="flex items-center space-x-3 mb-4">
                    <Cpu className="text-[#B6671D]" size={28} />
                    <h2 className="font-outfit text-3xl sm:text-4xl font-bold text-slate-950">
                      Department of Mechatronics Engineering
                    </h2>
                  </div>

                  <div className="space-y-4 font-inter text-slate-600 leading-relaxed">
                    <p>
                      The Department of Mechatronics Engineering at Manipal University Jaipur focuses on multidisciplinary
                      education and cutting-edge research in robotics, automation, embedded systems, and smart technologies.
                      The department is committed to preparing students for the challenges of Industry 4.0 and beyond.
                    </p>

                    {/* CTA Button */}
                    <div className="mt-6">
                      <a
                        href="https://jaipur.manipal.edu/fosta/department-of-mechatronics-engineering.php"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-[#B6671D] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#9A571A] transition"
                      >
                        Visit Department Page
                      </a>
                    </div>
                  </div>
                </motion.div>

                {/* Image */}
                <motion.div
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="relative rounded-2xl overflow-hidden">
                    <img 
                      src={deptimg}
                      alt="Department of Mechatronics Engineering"
                      className="w-full h-auto rounded-2xl shadow-xl"
                    />
                  </div>
                </motion.div>

              </div>
        </div>
      </section>

      {/* Keynote Speakers Section */}
     {/*  <section className="py-24 md:py-32 bg-slate-50" data-testid="speakers-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-center mb-12"
          >
            <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-950 mb-4">
              Keynote <span className="text-[#B6671D]">Speakers</span>
            </h2>
            <p className="font-inter text-lg text-slate-600">
              Distinguished experts sharing insights on robotics, automation, and smart manufacturing
            </p>
          </motion.div>

        
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[1, 2, 3].map((index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-xl transition-all group"
                data-testid={`speaker-card-${index}`}
              >
                
                <div className="aspect-square bg-slate-100 relative">
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Users className="text-slate-300" size={64} />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-outfit text-xl font-bold text-slate-950 mb-1">To Be Announced</h3>
                  <p className="font-inter text-[#B6671D] text-sm mb-2">Position / Title</p>
                  <p className="font-inter text-slate-600 text-sm">Institution / Organization</p>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="text-center mt-10">
            <Link to="/speakers">
              <Button
                variant="outline"
                className="border-2 border-slate-950 text-slate-950 hover:bg-slate-950 hover:text-white px-8 py-4 rounded-md font-medium transition-all"
              >
                View All Speakers
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section> */}

      {/* Call to Action */}
      <section className="py-20 bg-slate-950 noise-overlay" data-testid="cta-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="font-outfit text-3xl sm:text-4xl font-bold text-white mb-6">
              Ready to Join IRASM-2027?
            </h2>
            <p className="font-inter text-lg text-slate-300 mb-8 max-w-2xl mx-auto">
              Be part of the future of robotics and smart manufacturing. Submit your research or register for the conference today.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/for-authors">
                <Button
                  className="bg-[#B6671D] hover:bg-[#9A571A] text-white px-8 py-6 rounded-md font-semibold shadow-lg transition-all"
                  data-testid="view-dates-button"
                >
                  Author Guidelines
                  <ArrowRight className="ml-2" size={20} />
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;
